import Swiper, { Pagination, Navigation, Autoplay } from 'swiper';
import Plyr from 'plyr';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

Swiper.use([Navigation, Pagination, Autoplay]);

class SHORT_VIDEO {
  shortVideosPlay = null;
  plyrPlayer = null;

  constructor() {
    this.slider();
    this.pickShortVideo();
  }

  slider() {
    try {
      new Swiper('.short-video-slide .swiper', {
        speed: 1000,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        autoHeight: true,
        autoplay: {
          delay: 5000,
        },
        pagination: {
					el: '.short-video-slide .pagination',
					clickable: true,
					renderBullet: function (index, className) {
						index = index + 1
						return '<span class="' + className + '"></span>'
					},
				}
      });
    } catch (error) {
      console.log('dsd', error);
    }
  }

  pickShortVideo() {
    try {
      let _this = this;
      let listPickShort = document.querySelectorAll('.item-short');
      let shortVideoOverlay = document.querySelector('.short-video-overlay');
      let listPickShortOverlay = shortVideoOverlay.querySelectorAll('.item')
      let quitOverlay = shortVideoOverlay.querySelector('.quit');
      Array.from(listPickShort).forEach((item, index) => {
        item.addEventListener('click', e => {
          e.preventDefault()
          if (shortVideoOverlay.classList.contains('hidden')) {
            shortVideoOverlay.classList.remove('hidden');
            _this.shortVideosPlay = new Swiper('.short-video-overlay .swiper', {
              direction: 'vertical',
              slidesPerView: 1.2,
              initialSlide: index,
              spaceBetween: 30,
              loop: true,
              autoHeight: true,
              modules: [Navigation],
              navigation: {
                nextEl: '.short-video-overlay .button-next',
                prevEl: '.short-video-overlay .button-prev',
              },
            });
            _this.plyr(item.id);

            _this.shortVideosPlay.on('realIndexChange', evt => {
              _this.plyr(listPickShortOverlay[evt.realIndex].id);
            });
          }
        });
      });
      quitOverlay.addEventListener('click', () => {
        _this.shortVideosPlay.destroy(true, true);
        if (!shortVideoOverlay.classList.contains('hidden')) {
          shortVideoOverlay.classList.add('hidden');
          _this.plyrPlayer.destroy()
        }
      });
    } catch (error) {}
  }

  plyr(id) {
    try {
      let _this = this
      if (this.plyrPlayer) {
        this.plyrPlayer.destroy();
      }
      this.plyrPlayer = new Plyr(`#video-${id}`,  {controls: ['play-large']});
      this.plyrPlayer.muted = false
      this.plyrPlayer.play();

      let volume = document.querySelector('.short-video-overlay .volume')
      let volume_up = volume.querySelector('.up')
      let volume_off = volume.querySelector('.off')

      if (!_this.plyrPlayer.muted) {
        volume_up?.classList.remove('!hidden')
        volume_off?.classList.add('!hidden')
      } else {
        volume_up?.classList.add('!hidden')
        volume_off?.classList.remove('!hidden')
      }

      volume?.addEventListener('click', (evt) => {
        evt.stopImmediatePropagation()
          if (!_this.plyrPlayer.muted) {
            _this.plyrPlayer.muted = true
            volume_up?.classList.add('!hidden')
            volume_off?.classList.remove('!hidden')
          } else {
            _this.plyrPlayer.muted = false
            volume_up?.classList.remove('!hidden')
            volume_off?.classList.add('!hidden')
          }
      })

    } catch (error) {}
  }
}

export default window.addEventListener('DOMContentLoaded', evt => {
  new SHORT_VIDEO();
});
